const RELOAD_COOLDOWN_MS = 10 * 60 * 1000;
const RELOAD_COOLDOWN_KEY = 'mp:lastVersionReloadAt';

let lastSeenSha = null;
let mismatchCount = 0;
let updatePending = false;
let reloading = false;

export async function checkVersion() {
  const isLocalEnvironment = process.env.NODE_ENV === 'local' || location.origin.match('localhost');
  if (isLocalEnvironment) return;

  try {
    const currentAppVersion = process.env.APP_VERSION;
    const response = await fetch('/version.json', { cache: 'no-store' });
    const { sha } = await response.json();

    if (!sha || !currentAppVersion) return;

    if (sha === currentAppVersion) {
      mismatchCount = 0;
      return;
    }

    mismatchCount = sha === lastSeenSha ? mismatchCount + 1 : 1;
    lastSeenSha = sha;
    updatePending = mismatchCount >= 2;
  } catch (e) {
    console.error(e);
  }
}

function cooldownElapsed() {
  try {
    const last = Number(localStorage.getItem(RELOAD_COOLDOWN_KEY));
    return !last || Date.now() - last >= RELOAD_COOLDOWN_MS;
  } catch (e) {
    return true;
  }
}

function stampCooldown() {
  try {
    localStorage.setItem(RELOAD_COOLDOWN_KEY, String(Date.now()));
  } catch (e) {
    // Safari private mode throws on localStorage writes
  }
}

export function shouldReloadForUpdate() {
  return updatePending && cooldownElapsed();
}

export function reloadTo(fullPath) {
  if (reloading) return;
  reloading = true;
  stampCooldown();
  window.location.assign(fullPath);
}

export function isChunkLoadError(err) {
  return !!(err && (err.name === 'ChunkLoadError' || /Loading (CSS )?chunk [^ ]+ failed/i.test(err.message || '')));
}

export function recoverFromChunkError(fullPath) {
  if (!cooldownElapsed()) return false;
  reloadTo(fullPath);
  return true;
}
